import React from 'react';
import classnames from 'classnames';
import DevBudgetChangePercentage from '../../../Percentage';
import { formatDateStr } from '@gp/utils/common';
import { formatMilestoneDateByStatus } from '@gp/utils/milestone';

import type { IBaseProps } from '@home/types/common';
import type { IDevBudgetChangeVO } from '@gp/types/finance';

import './index.scss';

interface IDevBudgetChangeLineChartTooltipProps extends IBaseProps {
  title: string;
  data: IDevBudgetChangeVO | null;
  valueFormatter?: (payload: any) => string;
}

const DevBudgetChangeLineChartTooltip: React.FC<IDevBudgetChangeLineChartTooltipProps> = (props) => {
  const { style, className, title, data, valueFormatter } = props;

  const {
    milestone,
    date_confirm: dateConfirm,
    date,
    budget,
    budget_change: budgetChange,
    update_time: updateTime,
  } = data || {};

  return (
    <div
      style={style}
      className={classnames('dbg-project-details-finance-dev-budget-change-linechart-tooltip', className)}
    >
      <h2 className="dbg-project-details-finance-dev-budget-change-linechart-tooltip__title">{title}</h2>
      <ul className="dbg-project-details-finance-dev-budget-change-linechart-tooltip__list">
        <li className="dbg-project-details-finance-dev-budget-change-linechart-tooltip__item">
          <div className="dbg-project-details-finance-dev-budget-change-linechart-tooltip__item__left">
            {milestone} {!!date && `(${formatMilestoneDateByStatus(date, dateConfirm)})`}
          </div>
          <div className="dbg-project-details-finance-dev-budget-change-linechart-tooltip__item__right">
            {valueFormatter?.(budget) ?? budget}
          </div>
        </li>
        <li className="dbg-project-details-finance-dev-budget-change-linechart-tooltip__item">
          <div className="dbg-project-details-finance-dev-budget-change-linechart-tooltip__item__left">
            <div>Percentage Change</div>
            <div>(Between Current and Previous Milestone)</div>
          </div>
          <div className="dbg-project-details-finance-dev-budget-change-linechart-tooltip__item__right">
            <DevBudgetChangePercentage value={budgetChange} />
          </div>
        </li>
        <li className="dbg-project-details-finance-dev-budget-change-linechart-tooltip__item">
          <div className="dbg-project-details-finance-dev-budget-change-linechart-tooltip__item__left">Update time</div>
          <div className="dbg-project-details-finance-dev-budget-change-linechart-tooltip__item__right">
            {formatDateStr(updateTime) || '-'}
          </div>
        </li>
      </ul>
    </div>
  );
};

export default DevBudgetChangeLineChartTooltip;
